export const requiredRoleOptions = [
  { label: 'Delivery Only', value: 1 },
  { label: 'Project Manager', value: 2 },
  { label: 'Purchase Manager', value: 3 },
  { label: 'Purchase Officer', value: 4 },
  { label: 'QS', value: 5 },
  { label: 'Store Controller', value: 6 },
];

export const requiredRoleLabels = requiredRoleOptions.map((item) => item.label);

export const accountModuleOptions = [
  { label: 'Control Codes', value: '1' },
  { label: 'Debtors', value: '2' },
  { label: 'Ledger Codes', value: '3' },
  { label: 'Sub-Contractors', value: '4' },
  { label: 'Suppliers', value: '5' },
];

export enum ModuleOptions {
  PURCHASE = 1,
  ACCOUNTS,
  WGS,
}

export const moduleOptions = [
  { label: 'Purchase', value: '1' },
  { label: 'Accounts', value: '2' },
  { label: 'WGS', value: '3' },
];
